module.exports = __webpack_public_path__ + "img/name.d5f8cee0.png";